import { createFileRoute } from '@tanstack/react-router'

import { CreatePostPage } from '@/features/social-feed/page/CreatePostPage'

export const Route = createFileRoute('/_event/feed/nova-publicacao')({
  component: CreatePostPage
})
